import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  flex: 1;
`;

const Form = styled.div`
  width: 100%;
  max-width: 300px;
`;

const FormWrapper = ({ children }) => (
  <Container>
    <Form>{children}</Form>
  </Container>
);

export default FormWrapper;
